import React, { useState } from 'react';
import { Modal, Box, Typography, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';


// Define the modal style
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const Filter = ({ open, handleClose }) => {
  // States for selected filters
  const [selectedCostCenters, setSelectedCostCenters] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedDateFrom, setSelectedDateFrom] = useState(null);  // State for 'Date From'
  const [selectedDateTo, setSelectedDateTo] = useState(null);  // State for 'Date To'

  // Handle changes for the Cost Center filter
  const handleCostCenterChange = (event) => {
    setSelectedCostCenters(event.target.value);
  };

  // Handle changes for the Location filter
  const handleLocationChange = (event) => {
    setSelectedLocations(event.target.value);
  };

  // Handle 'Date From' change
  const handleDateFromChange = (newDate) => {
    setSelectedDateFrom(newDate);
  };

  // Handle 'Date To' change
  const handleDateToChange = (newDate) => {
    setSelectedDateTo(newDate);
  };

  // Handle Apply Filters action
  const handleApplyFilters = () => {
    console.log('Applied Filters:', { selectedCostCenters, selectedLocations, selectedDateFrom, selectedDateTo });
    handleClose();  // Close the modal after applying filters
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Filter Options
        </Typography>

        {/* Date From */}
        <FormControl fullWidth sx={{ mt: 2 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['DateRangePicker']}>
            <DateRangePicker
              slotProps={{
                textField: ({ position }) => ({
                  color: position === 'start' ? 'success' : 'warning',
                  focused: true,
                }),
              }}
              defaultValue={[dayjs('2022-04-17'), null]}
            />
          </DemoContainer>
          </LocalizationProvider>
        </FormControl>

        {/* Cost Center */}
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Cost Center</InputLabel>
          <Select
            label="Cost Center"
            multiple
            value={selectedCostCenters}
            onChange={handleCostCenterChange}
            renderValue={(selected) => selected.join(', ')}
          >
            <MenuItem value="BOILER">BOILER</MenuItem>
            <MenuItem value="C1 PLANT">C1 PLANT</MenuItem>
            <MenuItem value="CF1 PLANT">CF1 PLANT</MenuItem>
            <MenuItem value="EFFLUENT PLANT">EFFLUENT PLANT</MenuItem>
          </Select>
        </FormControl>

        {/* Location */}
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Location</InputLabel>
          <Select
            label="Location"
            multiple
            value={selectedLocations}
            onChange={handleLocationChange}
            renderValue={(selected) => selected.join(', ')}
          >
            <MenuItem value="BOILER">BOILER</MenuItem>
            <MenuItem value="C1 PLANT">C1 PLANT</MenuItem>
            <MenuItem value="CF1 PLANT">CF1 PLANT</MenuItem>
            <MenuItem value="EFFLUENT PLANT">EFFLUENT PLANT</MenuItem>
          </Select>
        </FormControl>

        {/* Apply Filter Button */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>
          <Button variant="contained" onClick={handleApplyFilters}>Apply Filters</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default Filter;
